export const getBusinessNameWithAdLabelStyles = (/* theme */) => ({
  businessNameWithAdsLabelRoot: {
    padding: [1, 0],
    overflow: 'hidden',
    marginTop: 9,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    color: '#333', // color: palette.black,
    fontSize: 10,
    lineHeight: '16px',

    '& .ads-label': {
      position: 'relative',
      padding: '.8px 4px',
      margin: '0 5px 0 0',
      background: 'transparent',
      color: '#78718a',
      lineHeight: 1.364,
      fontSize: '10px',
      fontWeight: '400',
      fontFamily: 'Segoe UI,Segoe WP,Arial,Sans-Serif',
      border: '.5px solid #78718a',
      borderRadius: '4px',
    },

    '& .business-name': {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      color: '#333',
      fontSize: 11,
      lineHeight: 1.364,
      padding: '1px 0',
      marginTop: 9,
    },
  },

  businuessNameRefreshed: {
    fontFamily: 'Segoe UI',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '20px',
    color: 'rgba(0, 0, 0, 1)',
  },
});
